import Dispatcher from "Dispatcher";
import FieldSetPreferenceCache from "data/util/FieldSetPreferenceCache";

export default new FieldSetPreferenceCache(Dispatcher, "user-hidden-fields");



// WEBPACK FOOTER //
// ./app/data/HiddenFieldStore.js